import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import logo from "../assets/skinlogo.jpg";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="bg-white text-gray-900 mb-16 py-4 px-6 shadow-md fixed w-full z-20 border-b border-gray-300">
      <div className="flex justify-between items-center max-w-7xl mx-auto">
        {/* Logo */}
        <div className="flex items-center space-x-3">
       <Link to='/'>   <img src={logo} alt="Logo" className="h-12 drop-shadow-lg" /></Link>
        </div>
        
        {/* Desktop Menu */}
        <div className="hidden md:flex space-x-8 text-lg font-semibold">
          {[
            { name: "Home", path: "/" },
            { name: "Consult a Doctor", path: "/consultation" },
            { name: "About", path: "/about" },
            { name: "Contact", path: "/contact" }
          ].map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className="relative group transition duration-300 hover:text-blue-600"
            >
              {item.name}
              <span className="absolute left-0 bottom-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full"></span>
            </Link>
          ))}
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden focus:outline-none" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <X className="h-8 w-8 text-gray-900" /> : <Menu className="h-8 w-8 text-gray-900" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`fixed top-0 right-0 h-full w-64 bg-white transform ${isOpen ? "translate-x-0" : "translate-x-full"} transition-transform duration-300 shadow-lg md:hidden`}
      >
        <button className="absolute top-5 right-5" onClick={() => setIsOpen(false)}>
          <X className="h-8 w-8 text-gray-900" />
        </button>
        <div className="flex flex-col items-center mt-16 space-y-6 text-lg font-semibold">
          {[
            { name: "Home", path: "/" },
            { name: "Consult a Doctor", path: "/consultation" },
            { name: "About", path: "/about" },
            { name: "Contact", path: "/contact" }
          ].map((item, index) => (
            <Link
              key={index}
              to={item.path}
              className="text-gray-900 hover:text-blue-600 transition-colors duration-300"
              onClick={() => setIsOpen(false)}
            >
              {item.name}
            </Link>
          ))}
        </div>
      </div>
    </nav>
  );
}